import { React, useState, useEffect } from "react";
const PopUpBetSlip = ({
  closeBetSlipParent,
  betObj,
  placeBetParent,
  betButtonShow,
  betButtonShowLoaderShow,
  betErrorMessageObj,
  stakeList
}) => {
  const [stakeValue, setStakeValue] = useState({ value: "" });
  const [profit, setProfitValue] = useState(0);
  const [liability, setLiabilityValue] = useState(0);
  const [showProfitLossCalculation, setProfitLossCalculation] = useState(false);
  const [betErrorMessage, setBetErrorMessage] = useState("");
  const [defaultAmount, setDefaultAmount] = useState("");

  let stake1 = 100;
  let stake2 = 200;
  let stake3 = 500;
  let stake4 = 1000;

  let stake5 = 5000;
  let stake6 = 10000;
  let stake7 = 20000;
  let stake8 = 50000;

  if (
    stakeList !== undefined &&
    stakeList !== null &&
    stakeList !== "" &&
    stakeList.stake1 !== undefined &&
    stakeList.stake1 !== null
  ) {
    stake1 = stakeList.stake1;
    stake2 = stakeList.stake2;
    stake3 = stakeList.stake3;
    stake4 = stakeList.stake4;

    stake5 = stakeList.stake5;
    stake6 = stakeList.stake6;
    stake7 = stakeList.stake7;
    stake8 = stakeList.stake8;
  }

  const closeBetSlipMobile = () => {
    setDefaultAmount("");
    closeBetSlipParent();
  };

  const place_bet = () => {
    if (defaultAmount > 0) {
      placeBetParent(defaultAmount);
    }
  };

  const getTypeAmount = (amount) => {
    amount = Number(amount);
    setDefaultAmount(amount);
  };

  useEffect(() => {
    if (betErrorMessageObj !== null && betErrorMessageObj !== undefined) {
      if (
        betErrorMessageObj.status !== null &&
        betErrorMessageObj.status !== undefined
      ) {
        if (betErrorMessageObj.status) {
          setBetErrorMessage("");

          //betSlipDisplayStatus = false;
        } else {
          setBetErrorMessage(betErrorMessageObj.message);
        }
      }
    }
  }, [betErrorMessageObj]);

  const setStake = (value) => {
    if (defaultAmount > 0) {
      let newValue = Number(defaultAmount) + Number(value);
      setDefaultAmount(newValue);
    } else {
      setDefaultAmount(value);
    }
    /*if (stakeValue.value > 0) {
      let newValue = stakeValue.value + value;
      setStakeValue({ value: newValue });
    } else {
      setStakeValue({ value });
    }*/
  };

  useEffect(() => {
    if (defaultAmount > 0) {
      setProfitLoss();
    }
  }, [defaultAmount]);

  const setProfitLoss = () => {
    if (betObj.market_type === "f" || betObj.market_type === "betfairfancy") {
      if (betObj.market_type === "betfairfancy") {
        betObj.price = 100;
      }

      if (betObj.bet_type === "l") {
        var bpro = defaultAmount;
        var lib = Math.round((betObj.price * defaultAmount) / 100);
        setLiabilityValue(lib);
        setProfitValue(bpro);
        setProfitLossCalculation(true);
      } else {
        var bpro = defaultAmount;
        var lib = Math.round((betObj.price * defaultAmount) / 100);
        setLiabilityValue(lib);
        setProfitValue(bpro);
        setProfitLossCalculation(true);
      }
    } else {
      if (betObj.bet_type === "b") {
        let liveRate = betObj.odds;
        if (liveRate > 0) {
          let liabilityNew = defaultAmount;
          setLiabilityValue(liabilityNew);

          let profitNew = Math.round(liveRate * liabilityNew - liabilityNew);
          setProfitValue(profitNew);
          setProfitLossCalculation(true);
        }
      } else {
        let liveRate = betObj.odds;
        if (liveRate > 0) {
          let profitNew = defaultAmount;
          setProfitValue(profitNew);

          let liabilityNew = Math.round(liveRate * profitNew - profitNew);
          setLiabilityValue(liabilityNew);
          setProfitLossCalculation(true);
        }
      }
    }
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };


  return (
    <div className="modal d-block">
      <div className="modal-dialog">
        <div className="modal-content" style={{ width: "99%" }}>
          <div style={{ borderRadius: "6px" }}>
            <form autocomplete="off" class="login-form mt-0">
              <div
                class="modal-body"
                style={{
                  borderRadius: "6px",
                  background:
                    betObj.bet_type === "b" || betObj.bet_type === "B"
                      ? "#e8f6fc"
                      : "#fce3e4"
                }}
              >
                <table>
                  <tbody>
                    <tr>
                      <td>&nbsp;</td>
                      <th colspan="3">
                        <span style={{ color: "#000" }}>
                          {betObj.runnername}
                        </span>
                      </th>
                    </tr>
                    <tr>
                      <td style={{ color: "#000" }}>ODDS</td>
                      <td colspan="2">
                        <div class="input-group mt-2">
                          <div class="input-group-prepend">
                            <button
                              type="button"
                              style={{
                                borderColor: "#6c757d",
                                color: "#6c757d"
                              }}
                              class="btn btn-outline-secondary"
                            >
                              <strong>-</strong>
                            </button>
                          </div>
                          <input
                            type="number"
                            step="0.01"
                            min="1.01"
                            max="50"
                            class="form-control"
                            value={betObj.odds}
                            style={{
                              border: "1px solid #ced4da",
                              color: "#495057",
                              padding: "0.375rem 0.75rem",
                              fontSize: "1rem",
                              lineHeight: "1.5"
                            }}
                          />

                          <div class="input-group-append">
                            <button
                              type="button"
                              style={{
                                borderColor: "#6c757d",
                                color: "#6c757d"
                              }}
                              class="btn btn-outline-secondary"
                            >
                              <strong>+</strong>
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ color: "#000" }}>Amount</td>
                      <td colspan="2">
                        <input
                          type="number"
                          onChange={(e) => getTypeAmount(e.target.value)}
                          value={defaultAmount}
                          class="form-control mt-2"
                          style={{
                            border: "1px solid #ced4da",
                            padding: "0.375rem 0.75rem",
                            fontSize: "1rem",
                            lineHeight: "1.5",
                            color: "#495057",
                            borderRadius: "0.25rem"
                          }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ width: "25%" }}>
                        <button
                          type="button"
                          class="btn btn-secondary btn-block mt-2"
                          style={{
                            touchAction: "manipulation",
                            backgroundColor: "#6c757d",
                            color: "white",
                            borderColor: "#6c757d",
                            fontSize: "1rem"
                          }}
                          onClick={() => setStake(stake1)}
                        >
                          {stake1}
                        </button>
                      </td>

                      <td style={{ width: "25%" }}>
                        <button
                          type="button"
                          class="btn btn-secondary btn-block mt-2"
                          style={{
                            touchAction: "manipulation",
                            backgroundColor: "#6c757d",
                            color: "white",
                            borderColor: "#6c757d",
                            fontSize: "1rem"
                          }}
                          onClick={() => setStake(stake2)}
                        >
                          {stake2}
                        </button>
                      </td>

                      <td style={{ width: "25%" }}>
                        <button
                          type="button"
                          class="btn btn-secondary btn-block mt-2"
                          style={{
                            touchAction: "manipulation",
                            backgroundColor: "#6c757d",
                            color: "white",
                            borderColor: "#6c757d",
                            fontSize: "1rem"
                          }}
                          onClick={() => setStake(stake3)}
                        >
                          {stake3}
                        </button>
                      </td>

                      <td style={{ width: "25%" }}>
                        <button
                          type="button"
                          class="btn btn-secondary btn-block mt-2"
                          style={{
                            touchAction: "manipulation",
                            backgroundColor: "#6c757d",
                            color: "white",
                            borderColor: "#6c757d",
                            fontSize: "1rem"
                          }}
                          onClick={() => setStake(stake4)}
                        >
                          {stake4}
                        </button>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ width: "25%" }}>
                        <button
                          type="button"
                          class="btn btn-secondary btn-block mt-2"
                          style={{
                            touchAction: "manipulation",
                            backgroundColor: "#6c757d",
                            color: "white",
                            borderColor: "#6c757d",
                            fontSize: "1rem"
                          }}
                          onClick={() => setStake(stake5)}
                        >
                          +{stake5}
                        </button>
                      </td>

                      <td style={{ width: "25%" }}>
                        <button
                          type="button"
                          class="btn btn-secondary btn-block mt-2"
                          style={{
                            touchAction: "manipulation",
                            backgroundColor: "#6c757d",
                            color: "white",
                            borderColor: "#6c757d",
                            fontSize: "1rem"
                          }}
                          onClick={() => setStake(stake6)}
                        >
                          +{stake6}
                        </button>
                      </td>

                      <td style={{ width: "25%" }}>
                        <button
                          type="button"
                          class="btn btn-secondary btn-block mt-2"
                          style={{
                            touchAction: "manipulation",
                            backgroundColor: "#6c757d",
                            color: "white",
                            borderColor: "#6c757d",
                            fontSize: "1rem"
                          }}
                          onClick={() => setStake(stake7)}
                        >
                          +{stake7}
                        </button>
                      </td>

                      <td style={{ width: "25%" }}>
                        <button
                          type="button"
                          class="btn btn-secondary btn-block mt-2"
                          style={{
                            touchAction: "manipulation",
                            backgroundColor: "#6c757d",
                            color: "white",
                            borderColor: "#6c757d",
                            fontSize: "1rem"
                          }}
                          onClick={() => setStake(stake8)}
                        >
                          +{stake8}
                        </button>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <button
                          type="button"
                          class="btn btn-danger mt-2"
                          style={{
                            touchAction: "manipulation",
                            backgroundColor: "#dc3545",
                            color: "white",
                            borderColor: "#dc3545",
                            fontSize: "1rem"
                          }}
                          onClick={() => closeBetSlipMobile()}
                        >
                          Close
                        </button>
                      </td>
                      <td colspan="3">
                        <button
                          type="button"
                          className="betsSubmit"
                          onClick={() => place_bet()}
                          style={{
                            marginRight: "4px",
                            marginTop: "14px",
                            border: "0px",
                            cursor: "pointer",
                            padding: "8px 19px",
                            display: betButtonShow ? "" : "none"
                          }}
                        >
                          <div>Submit</div>
                        </button>

                        <button
                          type="button"
                          className="betsSubmit"
                          style={{
                            marginRight: "4px",
                            marginTop: "14px",
                            border: "0px",
                            cursor: "pointer",
                            padding: "8px 19px",
                            display: betButtonShowLoaderShow ? "" : "none"
                          }}
                        >
                          <div>
                            Submit <div className="ld ld-ball ld-flip"></div>
                          </div>
                        </button>

                        <span
                          style={{
                            fontWeight: "bold",
                            paddingLeft: "10px",
                            display: showProfitLossCalculation ? "" : "none"
                          }}
                        >
                          <span style={{ color: "green" }}>
                            {formatTruncate(profit)}
                          </span>{" "}
                          <span style={{ color: "black" }}>/ -</span>{" "}
                          <span style={{ color: "red" }}>
                            {formatTruncate(liability)}
                          </span>
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <span style={{ color: "red" }}>{betErrorMessage}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUpBetSlip;
